import React, {useState} from "react";
import PropTypes from "prop-types";
import { useToasts } from "react-toast-notifications";
import { connect } from "react-redux";
import { addReviewToProducts } from "../../redux/actions/productsAction";
import Rating from '@material-ui/lab/Rating';
import { Box } from "@material-ui/core";
import { fetchRecensione } from "../../helpers/dbOperations";



const Recensione =({recensioni, userData, IDArt, addReviewToProducts}) =>
{

  const [inCaricamento, setinCaricamento] = useState(false);
  const [name, setName] = useState();
  const [userMail, setUserMail] = useState();
  const [userMessage, setUserMessage] = useState();
  const [userRating, setUserRating] = useState(5);
  const [recensioniState, setRecensioniState] = useState(recensioni);

  const { addToast } = useToasts();

function Stelline(num)
{
  const celle = [];

    for (var i = 0; i < num; i++)
    {
      celle.push(<i className="fa fa-star" /> )
    }

    return (
      <div className="review-rating">
      {celle}
      </div>
      );
}


  const handleSubmit = async e => {
    e.preventDefault();

    if (inCaricamento) return;

    setinCaricamento(true);
  
    var username = userData.user.user.username;
    var password  = userData.user.user.password;
    //console.log(userRating);
    var risultatoRecensione = await fetchRecensione({username, password, name, userMail, userMessage, userRating, IDArt});
    setinCaricamento(false);
  
    var Errore = risultatoRecensione?.Errore;
  
    if (Errore != "")
    {
      addToast(Errore, {appearance: "error", autoDismiss: true, placement: 'bottom-left' }); 
      return;
    }
  
    var newRec = {mail: userMail, messaggio: userMessage, patima: '', name: username, rating: userRating }
/*
    var localRec = recensioniState;
    localRec[localRec.length] = newRec;

    setRecensioniState(localRec);
*/
    //recensioni[recensioni.length] = (newRec);
    //setRecensioniState(recensioni);
    ////console.log(recensioni);

    addReviewToProducts(newRec, IDArt);

    var elements = document.querySelectorAll('[daAzz="'+"SI"+'"]');
        for (var ii = 0; ii < elements.length; ii++) {
            elements[ii].value = "";
        }
    setUserRating(5);
    
    addToast("Recensione aggiunta con successo", {appearance: "success", autoDismiss: true, placement: 'bottom-left' }); 
  }

return (
    <div className="row">
                  <div className="col-lg-7">
                    <div className="review-wrapper">
                      
                      
                  {recensioni?recensioniState.map((single, key) => 
                      {
                        return (
                      
                    (single.name)  && <div className="single-review">
                        <div className="review-img">
                          <img style = {{width: 100, height: 100}}
                            src={
                              single.patima
                            }
                            alt=""
                          />
                        </div>
                        <div className="review-content">

                        <div style = {{color: "#2e98f0"}}>
                              {single.mail}
                        </div>

                          <div className="review-top-wrap">
                            <div className="review-left">
                              <div className="review-name">
                                <h4>{single.name}</h4>
                              </div>

                              
                                  {Stelline(single.rating)}
                              

                            </div>
                            
                          </div>
                          <div className="review-bottom">
                            <p>{single.messaggio}
                            </p>
                          </div>
                        </div>
                      </div>
                        )
                      }):""}




                    </div>
                  </div>




                  <div className="col-lg-5">
                    <div className="pl-50">
                      <h3>Inserisci la Tua Recensione</h3>
                      <div className="ratting-form">
                        <form onSubmit={handleSubmit} action="#">
                          <div style={{flexDirection:"row", justifyContent:"center", alignItems: 'center', alignSelf:"center"}}>
                            <span style={{height:"32px !important"}}>Valutazione:</span>
                            <Rating
                              emptyLabelText= "Valutare il Prodotto"
                              name="hover-feedback"
                              precision={1}
                              defaultValue={5}
                              max={5}
                              size="large"
                              onChange={(event, newValue) => {
                                //console.log("On Change " + newValue)
                                setUserRating(newValue);
                              }}
                              onChangeActive={(event, newHover) => {
                               // setUserRating(newHover);
                              }}
                              />
                            {/*<div className="ratting-star">
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                              <i className="fa fa-star" />
                            </div>*/}
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="rating-form-style mb-10">
                                <input placeholder="Nome" 
                                type="text" 
                                daAzz = "SI"
                                onChange={e => setName(e.target.value)} />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="rating-form-style mb-10">
                                <input 
                                  placeholder="E-Mail" 
                                  type="email" 
                                  daAzz = "SI"
                                  onChange={e => setUserMail(e.target.value)} />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="rating-form-style form-submit">
                                <textarea
                                  onChange={e => setUserMessage(e.target.value)}
                                  name="Your Review"
                                  daAzz = "SI"
                                  placeholder="Messaggio"
                                  defaultValue={""}
                                />
                                <input type="submit" defaultValue="Submit" />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
)}


const mapStateToProps = state => {
  return {
    userData: state.userData
  };
};


Recensione.propTypes = {
  recensioni: PropTypes.object,
  userData: PropTypes.object,
  IDArt: PropTypes.number
};

const mapDispatchToProps = dispatch => {
  return {
    addReviewToProducts: (
      review, IDArt
    ) => dispatch(addReviewToProducts(review, IDArt))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Recensione);